module.exports = __webpack_public_path__ + "static/media/branch.a8a9aac3.svg";